module.exports = __webpack_public_path__ + "res/ic_edit.12cff5835d04c10bf99e7c099b6f8ac4.png";